export const MATH_QUEST_1_QUESTIONS = [
  {
    id: 'mq1_1',
    text: '7 + 5 = ____',
    category: 'Math Quest 1',
    grade_level: '1A-1B',
    correct_answer: '12',
  },
  {
    id: 'mq1_2',
    text: '9 - 4 = ___',
    category: 'Math Quest 1',
    grade_level: '1A-1B',
    correct_answer: '5',
  },
  {
    id: 'mq1_3',
    text: 'Choose the bigger number: 12 or 18?',
    category: 'Math Quest 1',
    grade_level: '1A-1B',
    correct_answer: '18',
  },
  {
    id: 'mq1_4',
    text: '8 + 7 = ___',
    category: 'Math Quest 1',
    grade_level: '1A-1B',
    correct_answer: '15',
  },
  {
    id: 'mq1_5',
    text: '15 - 6 = ___',
    category: 'Math Quest 1',
    grade_level: '1A-1B',
    correct_answer: '9',
  },
];
